import React, { useState, useEffect } from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import {
  Button,
  MobileStepper,
  Grid,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@material-ui/core";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import { autoPlay } from "react-swipeable-views-utils";
import SwipeableViews from "react-swipeable-views";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
const announcementBannerStyles = makeStyles((theme) => ({
  dailoguBox: {
    width: "500px",
    height: "auto",
    overflowX: "hidden",
  },
  iPhoneDailoguBox: {
    width: "auto",
    height: "auto",
    overflowX: "hidden",
  },
  customizedButton: {
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  root: {
    alignSelf: "center !important",
    background:"none !important"
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide ref={ref} {...props} />;
});
export default function AnnouncementPopup(props) {
  const theme = useTheme();
  const customStyle = announcementBannerStyles();
  const isTabletOrMobile = useMediaQuery({ query: "(min-width: 600px)" });
  const labels = useSelector(
    (state) => state?.labels?.data?.getLabels?.ANNOUNCEMENTS
  );

  const announcementDetails = useSelector((state) => {
    let fin =
      state?.announcementReducer?.annResults?.data?.getAnnouncementList.filter(
        (obj) => obj.AnnouncementType === "POPUP"
      );
    let ls = [];
    if (localStorage.getItem("popup")) {
      ls.push(localStorage.getItem("popup").split(","));
    }
    if (ls[0] === undefined) {
      return fin?.sort((a, b) => {
        let a_date_format = moment(a.StartDate).format("MM-DD-YYYY hh:mm:ss");
        let b_date_format = moment(b.StartDate).format("MM-DD-YYYY hh:mm:ss");
        return new Date(b_date_format) - new Date(a_date_format);
      });
    } else {
      var filtered = fin?.filter(function (e) {
        return this.indexOf(e.AnnouncementId.toString()) < 0;
      }, ls[0]);
      return filtered?.sort((a, b) => {
        let a_date_format = moment(a.StartDate).format("MM-DD-YYYY hh:mm:ss");
        let b_date_format = moment(b.StartDate).format("MM-DD-YYYY hh:mm:ss");
        return new Date(b_date_format) - new Date(a_date_format);
      });
    }
  });
  const [open, setOpen] = React.useState(true);
  const [openDismiss, setOpenDismiss] = React.useState(false);
  const [annFilter, setAnnFilter] = useState(announcementDetails);
  const [uniqueId, setUniqueId] = useState();

  const handleDismissYES = () => {
    let id = uniqueId.id;
    let ind = uniqueId.ind;
    setAnnFilter(announcementDetails.splice(ind, 1));
    let existing = localStorage.getItem("popup");
    existing = existing ? existing.split(",") : [];
    existing.push(id);
    localStorage.setItem("popup", existing.toString());
    setOpenDismiss(false);
    announcementDetails.length === 0 && setOpen(false);
  };

  const handleDismiss = (id, ind) => (e) => {
    setUniqueId({ id: id, ind: ind });
    setOpenDismiss(true);
  };

  const handleClose = () => {
    setOpenDismiss(false);
  };

  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = announcementDetails?.length;
  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  useEffect(() => {
    document.addEventListener("keydown", function (e) {
      switch (e.keyCode) {
        case 37:
          setActiveStep((prevActiveStep) =>
            prevActiveStep !== 0 ? prevActiveStep - 1 : 0
          );
          break;
        case 39:
          setActiveStep((prevActiveStep) =>
            prevActiveStep < maxSteps  ? prevActiveStep + 1 : 0
          );
          break;
      }
    });
  }, [maxSteps]);

  const dialogBox = (val, ind) => {
    return (
      <div
        key={ind}
        className={
          isTabletOrMobile
            ? customStyle.dailoguBox
            : customStyle.iPhoneDailoguBox
        }
      >
        <DialogTitle>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <strong> {labels?.ANNOUNCEMENT_TITLE}</strong>
            </Grid>
            <Grid item>
              <IconButton
                autoFocus
                color="primary"
                onClick={handleDismiss(val?.AnnouncementId, ind)}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span
              dangerouslySetInnerHTML={{
                __html: val?.AnnouncementDescription,
              }}
            ></span>
          </DialogContentText>
        </DialogContent>
      </div>
    );
  };

  return announcementDetails && announcementDetails.length > 0 ? (
    <>
      <Dialog open={open} scroll="paper" TransitionComponent={Transition}>
        {announcementDetails.length > 1 ? (
          <>
            <AutoPlaySwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={activeStep}
              onChangeIndex={handleStepChange}
              enableMouseEvents
              className={
                isTabletOrMobile
                  ? customStyle.dailoguBox
                  : customStyle.iPhoneDailoguBox
              }
            >
              {announcementDetails?.map((val, ind) => dialogBox(val, ind))}
            </AutoPlaySwipeableViews>
            <MobileStepper
              variant="dots"
              steps={announcementDetails?.length}
              position="static"
              activeStep={activeStep}
              className={customStyle.root}
            />
          </>
        ) : (
          dialogBox(announcementDetails[0], 0)
        )}
      </Dialog>
      <Dialog
        open={openDismiss}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {labels?.DISMISS_TITLE}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {labels?.DISMISS_CONTENT}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {labels?.DISMISS_NO}
          </Button>
          <Button onClick={handleDismissYES} color="primary" autoFocus>
            {labels?.DISMISS_YES}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  ) : null;
}
